module.exports = __webpack_public_path__ + "static/media/harukaze-logo.3fb681a5.svg";